<div   *ngIf="getTreeName()=='changeEmail' && nextStage">
    <verify-email   [instructions]="instructions"
                    autofocus="true"
                    [loginUrl]="loginRedirect"
                    (onVerifyEmail)="changeEmail($event)">
    </verify-email>
</div>